import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpHandler, HttpHandlerFn, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

export const CACHE_RESET_HEADER = 'x-reset-cache';
export const CACHE_SKIP_HEADER = 'x-skip-cache';

const cachedData = new Map<string, any>();
export const httpCacheInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  // Inject PLATFORM_ID to detect the current platform
  const platformId = inject(PLATFORM_ID);

  // Check if the current platform is the browser 
  if (!isPlatformBrowser(platformId)) {
    // If it's not the browser, we assume it's the server, so we bypass caching
    return next(req);
  }

  // console.log("***********Cache Instance Created From App******************");
  // console.log(req.url);
  if (req.headers.has(CACHE_RESET_HEADER) || ['POST', 'PUT', 'DELETE'].includes(req.method)) {
    window['GROUP_INFO'] = null;
    window['GROUP_ADDONS'] = null;
    cachedData.clear();
  }

  if (req.method !== 'GET' || req.headers.has(CACHE_SKIP_HEADER)) {
    return next(req);
  }

  const lastResponse = cachedData.get(req.urlWithParams);
  if (lastResponse) {
    return (lastResponse instanceof Observable)
      ? lastResponse : of(lastResponse.clone());
  }

  const requestHandle = next(req).pipe(
    tap((stateEvent) => {
      if (stateEvent instanceof HttpResponse) {
        cachedData.set(
          req.urlWithParams,
          stateEvent.clone()
        );
      }
    }),
    share()
  );

  cachedData.set(req.urlWithParams, requestHandle);

  return requestHandle; 
};